const locales = [
  { name: "Afar (Ddjibouti)", code: "aa_DJ" },
  { name: "Afar (Eritrea)", code: "aa_ER" },
  { name: "Afar (Ethiopia)", code: "aa_ET" },
  { name: "Afrikaans", code: "af" },
  { name: "Afrikaans (Namibia)", code: "af_NA" },
  { name: "Afrikaans (South Africa)", code: "af_ZA" },
  { name: "Akan", code: "ak" },
  { name: "Akan (Ghana)", code: "ak_GH" },
  { name: "Amharic", code: "am" },
  { name: "Amharic (Ethiopia)", code: "am_ET" },
  { name: "Aragonese (Spain)", code: "an_ES" },
  { name: "Arabic", code: "ar" },
  { name: "Arabic (United Arab Emirates)", code: "ar_AE" },
  { name: "Arabic (Bahrain)", code: "ar_BH" },
  { name: "Arabic (Algeria)", code: "ar_DZ" },
  { name: "Arabic (Egypt)", code: "ar_EG" },
  { name: "Arabic (India)", code: "ar_IN" },
  { name: "Arabic (Iraq)", code: "ar_IQ" },
  { name: "Arabic (Jordan)", code: "ar_JO" },
  { name: "Arabic (Kuwait)", code: "ar_KW" },
  { name: "Arabic (Lebanon)", code: "ar_LB" },
  { name: "Arabic (Libya)", code: "ar_LY" },
  { name: "Arabic (Morocco)", code: "ar_MA" },
  { name: "Arabic (Oman)", code: "ar_OM" },
  { name: "Arabic (Qatar)", code: "ar_QA" },
  { name: "Arabic (Saudi Arabia)", code: "ar_SA" },
  { name: "Arabic (Sudan)", code: "ar_SD" },
  { name: "Arabic (Syria)", code: "ar_SY" },
  { name: "Arabic (Tunisia)", code: "ar_TN" },
  { name: "Arabic (Yemen)", code: "ar_YE" },
  { name: "Assamese", code: "as" },
  { name: "Assamese (India)", code: "as_IN" },
  { name: "Asu", code: "asa" },
  { name: "Asu (Tanzania)", code: "asa_TZ" },
  { name: "Asturian (Spain)", code: "ast_ES" },
  { name: "Azerbaijani", code: "az" },
  { name: "Azerbaijani (Azerbaijan)", code: "az_AZ" },
  { name: "Azerbaijani (Cyrillic)", code: "az_Cyrl" },
  { name: "Azerbaijani (Cyrillic, Azerbaijan)", code: "az_Cyrl_AZ" },
  { name: "Azerbaijani (Latin)", code: "az_Latn" },
  { name: "Azerbaijani (Latin, Azerbaijan)", code: "az_Latn_AZ" },
  { name: "Belarusian", code: "be" },
  { name: "Belarusian (Belarus)", code: "be_BY" },
  { name: "Bemba", code: "bem" },
  { name: "Bemba (Zambia)", code: "bem_ZM" },
  { name: "UTF-8", code: "ber_DZ" },
  { name: "Berber (Morocco)", code: "ber_MA" },
  { name: "Bena", code: "bez" },
  { name: "Bena (Tanzania)", code: "bez_TZ" },
  { name: "Bulgarian", code: "bg" },
  { name: "Bulgarian (Bulgaria)", code: "bg_BG" },
  { name: "Bhojpuri (India)", code: "bho_IN" },
  { name: "Bambara", code: "bm" },
  { name: "Bambara (Mali)", code: "bm_ML" },
  { name: "Bengali", code: "bn" },
  { name: "Bengali (Bangladesh)", code: "bn_BD" },
  { name: "Bengali (India)", code: "bn_IN" },
  { name: "Tibetan", code: "bo" },
  { name: "Tibetan (China)", code: "bo_CN" },
  { name: "Tibetan (India)", code: "bo_IN" },
  { name: "Breton (France)", code: "br_FR" },
  { name: "Bodo (India)", code: "brx_IN" },
  { name: "Bosnian", code: "bs" },
  { name: "Bosnian (Bosnia and Herzegovina)", code: "bs_BA" },
  { name: "Bilin (Eritrea)", code: "byn_ER" },
  { name: "Catalan", code: "ca" },
  { name: "Catalan (Andorra)", code: "ca_AD" },
  { name: "Catalan (Spain)", code: "ca_ES" },
  { name: "Catalan (France)", code: "ca_FR" },
  { name: "Catalan (Italy)", code: "ca_IT" },
  { name: "Chiga", code: "cgg" },
  { name: "Chiga (Uganda)", code: "cgg_UG" },
  { name: "Cherokee", code: "chr" },
  { name: "Cherokee (United States)", code: "chr_US" },
  { name: "Crimean Tatar (Ukraine)", code: "crh_UA" },
  { name: "Czech", code: "cs" },
  { name: "Czech (Czech Republic)", code: "cs_CZ" },
  { name: "Kashubian (Poland)", code: "csb_PL" },
  { name: "Chuvash (Russia)", code: "cv_RU" },
  { name: "Welsh", code: "cy" },
  { name: "Welsh (United Kingdom)", code: "cy_GB" },
  { name: "Danish", code: "da" },
  { name: "Danish (Denmark)", code: "da_DK" },
  { name: "Taita", code: "dav" },
  { name: "Taita (Kenya)", code: "dav_KE" },
  { name: "German", code: "de" },
  { name: "German (Austria)", code: "de_AT" },
  { name: "German (Belgium)", code: "de_BE" },
  { name: "German (Switzerland)", code: "de_CH" },
  { name: "German (Germany)", code: "de_DE" },
  { name: "German (Liechtenstein)", code: "de_LI" },
  { name: "German (Luxembourg)", code: "de_LU" },
  { name: "Dhivehi (Maldives)", code: "dv_MV" },
  { name: "Dzongkha (Buthan)", code: "dz_BT" },
  { name: "Embu", code: "ebu" },
  { name: "Embu (Kenya)", code: "ebu_KE" },
  { name: "Ewe", code: "ee" },
  { name: "Ewe (Ghana)", code: "ee_GH" },
  { name: "Ewe (Togo)", code: "ee_TG" },
  { name: "Greek", code: "el" },
  { name: "Greek (Cyprus)", code: "el_CY" },
  { name: "Greek (Greece)", code: "el_GR" },
  { name: "English", code: "en" },
  { name: "English (Antigua & Barbuda)", code: "en_AG" },
  { name: "English (American Samoa)", code: "en_AS" },
  { name: "English (Australia)", code: "en_AU" },
  { name: "English (Belgium)", code: "en_BE" },
  { name: "English (Botswana)", code: "en_BW" },
  { name: "English (Belize)", code: "en_BZ" },
  { name: "English (Canada)", code: "en_CA" },
  { name: "English (Denmark)", code: "en_DK" },
  { name: "English (United Kingdom)", code: "en_GB" },
  { name: "English (Guam)", code: "en_GU" },
  { name: "English (Hong Kong SAR China)", code: "en_HK" },
  { name: "English (Ireland)", code: "en_IE" },
  { name: "English (India)", code: "en_IN" },
  { name: "English (Jamaica)", code: "en_JM" },
  { name: "English (Marshall Islands)", code: "en_MH" },
  { name: "English (Northern Mariana Islands)", code: "en_MP" },
  { name: "English (Malta)", code: "en_MT" },
  { name: "English (Mauritius)", code: "en_MU" },
  { name: "English (Namibia)", code: "en_NA" },
  { name: "UTF-8", code: "en_NG" },
  { name: "English (New Zealand)", code: "en_NZ" },
  { name: "English (Philippines)", code: "en_PH" },
  { name: "English (Pakistan)", code: "en_PK" },
  { name: "English (Singapore)", code: "en_SG" },
  { name: "English (Trinidad and Tobago)", code: "en_TT" },
  { name: "English (U.S. Minor Outlying Islands)", code: "en_UM" },
  { name: "English (United States)", code: "en_US" },
  { name: "English (U.S. Virgin Islands)", code: "en_VI" },
  { name: "English (South Africa)", code: "en_ZA" },
  { name: "English (Zambia)", code: "en_ZM" },
  { name: "English (Zimbabwe)", code: "en_ZW" },
  { name: "Esperanto", code: "eo" },
  { name: "Spanish", code: "es" },
  { name: "Spanish (Latin America)", code: "es_419" },
  { name: "Spanish (Argentina)", code: "es_AR" },
  { name: "Spanish (Bolivia)", code: "es_BO" },
  { name: "Spanish (Chile)", code: "es_CL" },
  { name: "Spanish (Colombia)", code: "es_CO" },
  { name: "Spanish (Costa Rica)", code: "es_CR" },
  { name: "Spanish (Cuba)", code: "es_CU" },
  { name: "Spanish (Dominican Republic)", code: "es_DO" },
  { name: "Spanish (Ecuador)", code: "es_EC" },
  { name: "Spanish (Spain)", code: "es_ES" },
  { name: "Spanish (Equatorial Guinea)", code: "es_GQ" },
  { name: "Spanish (Guatemala)", code: "es_GT" },
  { name: "Spanish (Honduras)", code: "es_HN" },
  { name: "Spanish (Mexico)", code: "es_MX" },
  { name: "Spanish (Nicaragua)", code: "es_NI" },
  { name: "Spanish (Panama)", code: "es_PA" },
  { name: "Spanish (Peru)", code: "es_PE" },
  { name: "Spanish (Puerto Rico)", code: "es_PR" },
  { name: "Spanish (Paraguay)", code: "es_PY" },
  { name: "Spanish (El Salvador)", code: "es_SV" },
  { name: "Spanish (United States)", code: "es_US" },
  { name: "Spanish (Uruguay)", code: "es_UY" },
  { name: "Spanish (Venezuela)", code: "es_VE" },
  { name: "Estonian", code: "et" },
  { name: "Estonian (Estonia)", code: "et_EE" },
  { name: "Basque", code: "eu" },
  { name: "Basque (Spain)", code: "eu_ES" },
  { name: "Persian", code: "fa" },
  { name: "Persian (Afghanistan)", code: "fa_AF" },
  { name: "Persian (Iran)", code: "fa_IR" },
  { name: "Fulah", code: "ff" },
  { name: "Fulah (Senegal)", code: "ff_SN" },
  { name: "Finnish", code: "fi" },
  { name: "Finnish (Finland)", code: "fi_FI" },
  { name: "Filipino", code: "fil" },
  { name: "Filipino (Philippines)", code: "fil_PH" },
  { name: "Faroese", code: "fo" },
  { name: "Faroese (Faroe Islands)", code: "fo_FO" },
  { name: "French", code: "fr" },
  { name: "French (Belgium)", code: "fr_BE" },
  { name: "French (Burkina Faso)", code: "fr_BF" },
  { name: "French (Burundi)", code: "fr_BI" },
  { name: "French (Benin)", code: "fr_BJ" },
  { name: "French (Saint Barthélemy)", code: "fr_BL" },
  { name: "French (Canada)", code: "fr_CA" },
  { name: "French (Congo - Kinshasa)", code: "fr_CD" },
  { name: "French (Central African Republic)", code: "fr_CF" },
  { name: "French (Congo - Brazzaville)", code: "fr_CG" },
  { name: "French (Switzerland)", code: "fr_CH" },
  { name: "French (Côte d’Ivoire)", code: "fr_CI" },
  { name: "French (Cameroon)", code: "fr_CM" },
  { name: "French (Djibouti)", code: "fr_DJ" },
  { name: "French (France)", code: "fr_FR" },
  { name: "French (Gabon)", code: "fr_GA" },
  { name: "French (Guinea)", code: "fr_GN" },
  { name: "French (Guadeloupe)", code: "fr_GP" },
  { name: "French (Equatorial Guinea)", code: "fr_GQ" },
  { name: "French (Comoros)", code: "fr_KM" },
  { name: "French (Luxembourg)", code: "fr_LU" },
  { name: "French (Monaco)", code: "fr_MC" },
  { name: "French (Saint Martin)", code: "fr_MF" },
  { name: "French (Madagascar)", code: "fr_MG" },
  { name: "French (Mali)", code: "fr_ML" },
  { name: "French (Martinique)", code: "fr_MQ" },
  { name: "French (Niger)", code: "fr_NE" },
  { name: "French (Réunion)", code: "fr_RE" },
  { name: "French (Rwanda)", code: "fr_RW" },
  { name: "French (Senegal)", code: "fr_SN" },
  { name: "French (Chad)", code: "fr_TD" },
  { name: "French (Togo)", code: "fr_TG" },
  { name: "Friulian (Italy)", code: "fur_IT" },
  { name: "Western Frisian (Germany)", code: "fy_DE" },
  { name: "Western Frisian (Netherlands)", code: "fy_NL" },
  { name: "Irish", code: "ga" },
  { name: "Irish (Ireland)", code: "ga_IE" },
  { name: "Scottish Gaelic (United Kingdom)", code: "gd_GB" },
  { name: "Geez (Eritrea)", code: "gez_ER" },
  { name: "Geez (Ethiopia)", code: "gez_ET" },
  { name: "Galician", code: "gl" },
  { name: "Galician (Spain)", code: "gl_ES" },
  { name: "Swiss German", code: "gsw" },
  { name: "Swiss German (Switzerland)", code: "gsw_CH" },
  { name: "Gujarati", code: "gu" },
  { name: "Gujarati (India)", code: "gu_IN" },
  { name: "Gusii", code: "guz" },
  { name: "Gusii (Kenya)", code: "guz_KE" },
  { name: "Manx", code: "gv" },
  { name: "Manx (United Kingdom)", code: "gv_GB" },
  { name: "Hausa", code: "ha" },
  { name: "Hausa (Latin)", code: "ha_Latn" },
  { name: "Hausa (Latin, Ghana)", code: "ha_Latn_GH" },
  { name: "Hausa (Latin, Niger)", code: "ha_Latn_NE" },
  { name: "Hausa (Latin, Nigeria)", code: "ha_Latn_NG" },
  { name: "Hausa (Nigeria)", code: "ha_NG" },
  { name: "Hawaiian", code: "haw" },
  { name: "Hawaiian (United States)", code: "haw_US" },
  { name: "Hebrew", code: "he" },
  { name: "Hebrew (Israel)", code: "he_IL" },
  { name: "Hindi", code: "hi" },
  { name: "Hindi (India)", code: "hi_IN" },
  { name: "Chhattisgarhi (India)", code: "hne_IN" },
  { name: "Croatian", code: "hr" },
  { name: "Croatian (Croatia)", code: "hr_HR" },
  { name: "Upper Sorbian (Germany)", code: "hsb_DE" },
  { name: "Haitian (Haiti)", code: "ht_HT" },
  { name: "Hungarian", code: "hu" },
  { name: "Hungarian (Hungary)", code: "hu_HU" },
  { name: "Armenian", code: "hy" },
  { name: "Armenian (Armenia)", code: "hy_AM" },
  { name: "Indonesian", code: "id" },
  { name: "Indonesian (Indonesia)", code: "id_ID" },
  { name: "Igbo", code: "ig" },
  { name: "Igbo (Nigeria)", code: "ig_NG" },
  { name: "Sichuan Yi", code: "ii" },
  { name: "Sichuan Yi (China)", code: "ii_CN" },
  { name: "Inupiaq (Canada)", code: "ik_CA" },
  { name: "Icelandic", code: "is" },
  { name: "Icelandic (Iceland)", code: "is_IS" },
  { name: "Italian", code: "it" },
  { name: "Italian (Switzerland)", code: "it_CH" },
  { name: "Italian (Italy)", code: "it_IT" },
  { name: "Inuktitut (Canada)", code: "iu_CA" },
  { name: "Hebrew (Israel)", code: "iw_IL" },
  { name: "Japanese", code: "ja" },
  { name: "Japanese (Japan)", code: "ja_JP" },
  { name: "Machame", code: "jmc" },
  { name: "Machame (Tanzania)", code: "jmc_TZ" },
  { name: "Georgian", code: "ka" },
  { name: "Georgian (Georgia)", code: "ka_GE" },
  { name: "Kabyle", code: "kab" },
  { name: "Kabyle (Algeria)", code: "kab_DZ" },
  { name: "Kamba", code: "kam" },
  { name: "Kamba (Kenya)", code: "kam_KE" },
  { name: "Makonde", code: "kde" },
  { name: "Makonde (Tanzania)", code: "kde_TZ" },
  { name: "Kabuverdianu", code: "kea" },
  { name: "Kabuverdianu (Cape Verde)", code: "kea_CV" },
  { name: "Koyra Chiini", code: "khq" },
  { name: "Koyra Chiini (Mali)", code: "khq_ML" },
  { name: "Kikuyu", code: "ki" },
  { name: "Kikuyu (Kenya)", code: "ki_KE" },
  { name: "Kazakh", code: "kk" },
  { name: "Kazakh (Cyrillic)", code: "kk_Cyrl" },
  { name: "Kazakh (Cyrillic, Kazakhstan)", code: "kk_Cyrl_KZ" },
  { name: "Kazakh (Kazakhstan)", code: "kk_KZ" },
  { name: "Kalaallisut", code: "kl" },
  { name: "Kalaallisut (Greenland)", code: "kl_GL" },
  { name: "Kalenjin", code: "kln" },
  { name: "Kalenjin (Kenya)", code: "kln_KE" },
  { name: "Khmer", code: "km" },
  { name: "Khmer (Cambodia)", code: "km_KH" },
  { name: "Kannada", code: "kn" },
  { name: "Kannada (India)", code: "kn_IN" },
  { name: "Korean", code: "ko" },
  { name: "Korean (South Korea)", code: "ko_KR" },
  { name: "Konkani", code: "kok" },
  { name: "Konkani (India)", code: "kok_IN" },
  { name: "Kashmiri (India)", code: "ks_IN" },
  { name: "Kurdish (Turkey)", code: "ku_TR" },
  { name: "Cornish", code: "kw" },
  { name: "Cornish (United Kingdom)", code: "kw_GB" },
  { name: "Kirghiz (Kyrgyzstan)", code: "ky_KG" },
  { name: "Langi", code: "lag" },
  { name: "Langi (Tanzania)", code: "lag_TZ" },
  { name: "Luxembourgish (Luxembourg)", code: "lb_LU" },
  { name: "Ganda", code: "lg" },
  { name: "Ganda (Uganda)", code: "lg_UG" },
  { name: "Limburgan (Belgium)", code: "li_BE" },
  { name: "Limburgan (Netherlands)", code: "li_NL" },
  { name: "Ligurian (Italy)", code: "lij_IT" },
  { name: "Lao (Laos)", code: "lo_LA" },
  { name: "Lithuanian", code: "lt" },
  { name: "Lithuanian (Lithuania)", code: "lt_LT" },
  { name: "Luo", code: "luo" },
  { name: "Luo (Kenya)", code: "luo_KE" },
  { name: "Luyia", code: "luy" },
  { name: "Luyia (Kenya)", code: "luy_KE" },
  { name: "Latvian", code: "lv" },
  { name: "Latvian (Latvia)", code: "lv_LV" },
  { name: "Magahi (India)", code: "mag_IN" },
  { name: "Maithili (India)", code: "mai_IN" },
  { name: "Masai", code: "mas" },
  { name: "Masai (Kenya)", code: "mas_KE" },
  { name: "Masai (Tanzania)", code: "mas_TZ" },
  { name: "Meru", code: "mer" },
  { name: "Meru (Kenya)", code: "mer_KE" },
  { name: "Morisyen", code: "mfe" },
  { name: "Morisyen (Mauritius)", code: "mfe_MU" },
  { name: "Malagasy", code: "mg" },
  { name: "Malagasy (Madagascar)", code: "mg_MG" },
  { name: "Eastern Mari (Russia)", code: "mhr_RU" },
  { name: "Maori (New Zealand)", code: "mi_NZ" },
  { name: "Macedonian", code: "mk" },
  { name: "Macedonian (Macedonia)", code: "mk_MK" },
  { name: "Malayalam", code: "ml" },
  { name: "Malayalam (India)", code: "ml_IN" },
  { name: "Mongolian (Mongolia)", code: "mn_MN" },
  { name: "Marathi", code: "mr" },
  { name: "Marathi (India)", code: "mr_IN" },
  { name: "Malay", code: "ms" },
  { name: "Malay (Brunei)", code: "ms_BN" },
  { name: "Malay (Malaysia)", code: "ms_MY" },
  { name: "Maltese", code: "mt" },
  { name: "Maltese (Malta)", code: "mt_MT" },
  { name: "Burmese", code: "my" },
  { name: "Burmese (Myanmar [Burma])", code: "my_MM" },
  { name: "Min Nan Chinese (Taiwan)", code: "nan_TW" },
  { name: "Nama", code: "naq" },
  { name: "Nama (Namibia)", code: "naq_NA" },
  { name: "Norwegian Bokmål", code: "nb" },
  { name: "Norwegian Bokmål (Norway)", code: "nb_NO" },
  { name: "North Ndebele", code: "nd" },
  { name: "North Ndebele (Zimbabwe)", code: "nd_ZW" },
  { name: "Low German (German)", code: "nds_DE" },
  { name: "Low German (Netherlands)", code: "nds_NL" },
  { name: "Nepali", code: "ne" },
  { name: "Nepali (India)", code: "ne_IN" },
  { name: "Nepali (Nepal)", code: "ne_NP" },
  { name: "Dutch", code: "nl" },
  { name: "Dutch (Aruba)", code: "nl_AW" },
  { name: "Dutch (Belgium)", code: "nl_BE" },
  { name: "Dutch (Netherlands)", code: "nl_NL" },
  { name: "Norwegian Nynorsk", code: "nn" },
  { name: "Norwegian Nynorsk (Norway)", code: "nn_NO" },
  { name: "South Ndebele (South Africa)", code: "nr_ZA" },
  { name: "Pedi (South Africa)", code: "nso_ZA" },
  { name: "Nyankole", code: "nyn" },
  { name: "Nyankole (Uganda)", code: "nyn_UG" },
  { name: "Occitan (France)", code: "oc_FR" },
  { name: "Oromo", code: "om" },
  { name: "Oromo (Ethiopia)", code: "om_ET" },
  { name: "Oromo (Kenya)", code: "om_KE" },
  { name: "Oriya", code: "or" },
  { name: "Oriya (India)", code: "or_IN" },
  { name: "Ossetian (Russia)", code: "os_RU" },
  { name: "Punjabi", code: "pa" },
  { name: "Punjabi (Arabic)", code: "pa_Arab" },
  { name: "Punjabi (Arabic, Pakistan)", code: "pa_Arab_PK" },
  { name: "Punjabi (Gurmukhi)", code: "pa_Guru" },
  { name: "Punjabi (Gurmukhi, India)", code: "pa_Guru_IN" },
  { name: "Panjabi (India)", code: "pa_IN" },
  { name: "Panjabi (Pakistan)", code: "pa_PK" },
  { name: "Papiamento (Netherlands)", code: "pap_AN" },
  { name: "Polish", code: "pl" },
  { name: "Polish (Poland)", code: "pl_PL" },
  { name: "Pashto", code: "ps" },
  { name: "Pashto (Afghanistan)", code: "ps_AF" },
  { name: "Portuguese", code: "pt" },
  { name: "Portuguese (Brazil)", code: "pt_BR" },
  { name: "Portuguese (Guinea-Bissau)", code: "pt_GW" },
  { name: "Portuguese (Mozambique)", code: "pt_MZ" },
  { name: "Portuguese (Portugal)", code: "pt_PT" },
  { name: "Romansh", code: "rm" },
  { name: "Romansh (Switzerland)", code: "rm_CH" },
  { name: "Romanian", code: "ro" },
  { name: "Romanian (Moldova)", code: "ro_MD" },
  { name: "Romanian (Romania)", code: "ro_RO" },
  { name: "Rombo", code: "rof" },
  { name: "Rombo (Tanzania)", code: "rof_TZ" },
  { name: "Russian", code: "ru" },
  { name: "Russian (Moldova)", code: "ru_MD" },
  { name: "Russian (Russia)", code: "ru_RU" },
  { name: "Russian (Ukraine)", code: "ru_UA" },
  { name: "Kinyarwanda", code: "rw" },
  { name: "Kinyarwanda (Rwanda)", code: "rw_RW" },
  { name: "Rwa", code: "rwk" },
  { name: "Rwa (Tanzania)", code: "rwk_TZ" },
  { name: "Sanskrit (India)", code: "sa_IN" },
  { name: "Samburu", code: "saq" },
  { name: "Samburu (Kenya)", code: "saq_KE" },
  { name: "Sardinian (Italy)", code: "sc_IT" },
  { name: "Sindhi (India)", code: "sd_IN" },
  { name: "Northern Sami (Norway)", code: "se_NO" },
  { name: "Sena", code: "seh" },
  { name: "Sena (Mozambique)", code: "seh_MZ" },
  { name: "Koyraboro Senni", code: "ses" },
  { name: "Koyraboro Senni (Mali)", code: "ses_ML" },
  { name: "Sango", code: "sg" },
  { name: "Sango (Central African Republic)", code: "sg_CF" },
  { name: "Tachelhit", code: "shi" },
  { name: "Tachelhit (Latin)", code: "shi_Latn" },
  { name: "Tachelhit (Latin, Morocco)", code: "shi_Latn_MA" },
  { name: "Tachelhit (Tifinagh)", code: "shi_Tfng" },
  { name: "Tachelhit (Tifinagh, Morocco)", code: "shi_Tfng_MA" },
  { name: "Shuswap (Canada)", code: "shs_CA" },
  { name: "Sinhala", code: "si" },
  { name: "Sinhala (Sri Lanka)", code: "si_LK" },
  { name: "Sidamo (Ethiopia)", code: "sid_ET" },
  { name: "Slovak", code: "sk" },
  { name: "Slovak (Slovakia)", code: "sk_SK" },
  { name: "Slovenian", code: "sl" },
  { name: "Slovenian (Slovenia)", code: "sl_SI" },
  { name: "Shona", code: "sn" },
  { name: "Shona (Zimbabwe)", code: "sn_ZW" },
  { name: "Somali", code: "so" },
  { name: "Somali (Djibouti)", code: "so_DJ" },
  { name: "Somali (Ethiopia)", code: "so_ET" },
  { name: "Somali (Kenya)", code: "so_KE" },
  { name: "Somali (Somalia)", code: "so_SO" },
  { name: "Albanian", code: "sq" },
  { name: "Albanian (Albania)", code: "sq_AL" },
  { name: "Albanian (Macedonia)", code: "sq_MK" },
  { name: "Serbian", code: "sr" },
  { name: "Serbian (Cyrillic)", code: "sr_Cyrl" },
  { name: "Serbian (Cyrillic, Bosnia and Herzegovina)", code: "sr_Cyrl_BA" },
  { name: "Serbian (Cyrillic, Montenegro)", code: "sr_Cyrl_ME" },
  { name: "Serbian (Cyrillic, Serbia)", code: "sr_Cyrl_RS" },
  { name: "Serbian (Latin)", code: "sr_Latn" },
  { name: "Serbian (Latin, Bosnia and Herzegovina)", code: "sr_Latn_BA" },
  { name: "Serbian (Latin, Montenegro)", code: "sr_Latn_ME" },
  { name: "Serbian (Latin, Serbia)", code: "sr_Latn_RS" },
  { name: "Serbian (Montenegro)", code: "sr_ME" },
  { name: "Serbian (Serbia)", code: "sr_RS" },
  { name: "Swati (South Africa)", code: "ss_ZA" },
  { name: "Southern Sotho (South Africa)", code: "st_ZA" },
  { name: "Swedish", code: "sv" },
  { name: "Swedish (Finland)", code: "sv_FI" },
  { name: "Swedish (Sweden)", code: "sv_SE" },
  { name: "Swahili", code: "sw" },
  { name: "Swahili (Kenya)", code: "sw_KE" },
  { name: "Swahili (Tanzania)", code: "sw_TZ" },
  { name: "Tamil", code: "ta" },
  { name: "Tamil (India)", code: "ta_IN" },
  { name: "Tamil (Sri Lanka)", code: "ta_LK" },
  { name: "Telugu", code: "te" },
  { name: "Telugu (India)", code: "te_IN" },
  { name: "Teso", code: "teo" },
  { name: "Teso (Kenya)", code: "teo_KE" },
  { name: "Teso (Uganda)", code: "teo_UG" },
  { name: "Tajik (Tajikistan)", code: "tg_TJ" },
  { name: "Thai", code: "th" },
  { name: "Thai (Thailand)", code: "th_TH" },
  { name: "Tigrinya", code: "ti" },
  { name: "Tigrinya (Eritrea)", code: "ti_ER" },
  { name: "Tigrinya (Ethiopia)", code: "ti_ET" },
  { name: "Tigre (Eritrea)", code: "tig_ER" },
  { name: "Turkmen (Turkmenistan)", code: "tk_TM" },
  { name: "Tagalog (Philippines)", code: "tl_PH" },
  { name: "Tswana (South Africa)", code: "tn_ZA" },
  { name: "Tonga", code: "to" },
  { name: "Tonga (Tonga)", code: "to_TO" },
  { name: "Turkish", code: "tr" },
  { name: "Turkish (Cyprus)", code: "tr_CY" },
  { name: "Turkish (Turkey)", code: "tr_TR" },
  { name: "Tsonga (South Africa)", code: "ts_ZA" },
  { name: "Tatar (Russia)", code: "tt_RU" },
  { name: "Central Morocco Tamazight", code: "tzm" },
  { name: "Central Morocco Tamazight (Latin)", code: "tzm_Latn" },
  { name: "Central Morocco Tamazight (Latin, Morocco)", code: "tzm_Latn_MA" },
  { name: "Uighur (China)", code: "ug_CN" },
  { name: "Ukrainian", code: "uk" },
  { name: "Ukrainian (Ukraine)", code: "uk_UA" },
  { name: "Unami (America)", code: "unm_US" },
  { name: "Urdu", code: "ur" },
  { name: "Urdu (India)", code: "ur_IN" },
  { name: "Urdu (Pakistan)", code: "ur_PK" },
  { name: "Uzbek", code: "uz" },
  { name: "Uzbek (Arabic)", code: "uz_Arab" },
  { name: "Uzbek (Arabic, Afghanistan)", code: "uz_Arab_AF" },
  { name: "Uzbek (Cyrillic)", code: "uz_Cyrl" },
  { name: "Uzbek (Cyrillic, Uzbekistan)", code: "uz_Cyrl_UZ" },
  { name: "Uzbek (Latin)", code: "uz_Latn" },
  { name: "Uzbek (Latin, Uzbekistan)", code: "uz_Latn_UZ" },
  { name: "Uzbek (Uzbekistan)", code: "uz_UZ" },
  { name: "Venda (South Africa)", code: "ve_ZA" },
  { name: "Vietnamese", code: "vi" },
  { name: "Vietnamese (Vietnam)", code: "vi_VN" },
  { name: "Vunjo", code: "vun" },
  { name: "Vunjo (Tanzania)", code: "vun_TZ" },
  { name: "Walloon (Belgium)", code: "wa_BE" },
  { name: "Walser (Switzerland)", code: "wae_CH" },
  { name: "Wolaytta (Ethiopia)", code: "wal_ET" },
  { name: "Wolof (Senegal)", code: "wo_SN" },
  { name: "Xhosa South Africa)", code: "xh_ZA" },
  { name: "Soga", code: "xog" },
  { name: "Soga (Uganda)", code: "xog_UG" },
  { name: "Yiddish (America)", code: "yi_US" },
  { name: "Yoruba", code: "yo" },
  { name: "Yoruba (Nigeria)", code: "yo_NG" },
  { name: "Yue Chinese (China)", code: "yue_HK" },
  { name: "Chinese", code: "zh" },
  { name: "Chinese (China)", code: "zh_CN" },
  { name: "Chinese (Hong Kong)", code: "zh_HK" },
  { name: "Chinese (Simplified Han)", code: "zh_Hans" },
  { name: "Chinese (Simplified Han, China)", code: "zh_Hans_CN" },
  { name: "Chinese (Simplified Han, Hong Kong SAR China)", code: "zh_Hans_HK" },
  { name: "Chinese (Simplified Han, Macau SAR China)", code: "zh_Hans_MO" },
  { name: "Chinese (Simplified Han, Singapore)", code: "zh_Hans_SG" },
  { name: "Chinese (Traditional Han)", code: "zh_Hant" },
  {
    name: "Chinese (Traditional Han, Hong Kong SAR China)",
    code: "zh_Hant_HK",
  },
  { name: "Chinese (Traditional Han, Macau SAR China)", code: "zh_Hant_MO" },
  { name: "Chinese (Traditional Han, Taiwan)", code: "zh_Hant_TW" },
  { name: "Chinese (Singapore)", code: "zh_SG" },
  { name: "Chinese (Taiwan)", code: "zh_TW" },
  { name: "Zulu", code: "zu" },
  { name: "Zulu (South Africa)", code: "zu_ZA" },
];

export default locales;
